import builder from '../builder';
import CreditCardAmex from '../../streamline-icons/bold/credit-card-amex.svg';

export default builder('IconCreditCardAmexBold', CreditCardAmex);
